<template>
  <div>
    <div class="mt-3">
      <b-card border-variant="dark" header="通知服務" align="center">
        <b-card-text>
          若啟用本服務，每當客戶發訊息時，
          系統都會透過LINE通知您
          請確保您的手機已經安裝了LINE APP
          並且登入
          本服務會自動跳至LINEApp進行授權，
          初次啟用時請務必按下【允許】
        </b-card-text>
        <b-checkbox
          @change="setting"
          id="checkbox-1"
          v-model="notifystatus"
          name="checkbox-1"
          value="1"
          unchecked-value="0"
        >啟用</b-checkbox>
        <a id="liff" :href="liffUrl" target="_blank" v-show="false"></a>
      </b-card>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export default {
  data() {
    return {
      staffInfo: null,
      notifystatus: "0",
      liffUrl: ""
    };
  },

  created() {
    var that = this;
    let staff = this.GetLoginStaff();
    this.$axios
      .post(
        "SocialLeadPairedBasisInfo/GetStaffInfo",
        qs.stringify({
          staffId: staff.staffid
        })
      )
      .then(function(response) {
        that.staffInfo = response.data;
        if (
          that.staffInfo.LineUserId == null ||
          that.staffInfo.LineUserId == undefined
        ) {
          that.staffInfo.LineUserId = "";
        }
        that.notifystatus = that.staffInfo.LineUserId != "" ? "1" : "0";
        that.liffUrl =
          webTypeApiUrl.LIFF.BindingStaffLineUserId +
          "?Code=" +
          that.staffInfo.RecommendCode;
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  methods: {
    setting(value) {
      var that = this;
      if (value == "1") {
        document.getElementById("liff").click();
      } else {
        this.$axios
          .post(
            "SCRMApp/CancelLineNotify",
            qs.stringify({
              staffsn: this.staffInfo.StaffSn
            })
          )
          .then(function(response) {
            that.$message({
              message: "變更完成",
              type: "success"
            });
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/SaleAgentNotifySetting.vue